<div class="nav nav-wide">
    <div class="contact-header" style="background:black;width:100%">
        <div style="padding:0.7rem">
            <span style="color:white;">
                <i style="color:darkorange" class="fa fa-envelope"></i>
                <a style="color:white;" href="mailto:info@sinirji.com">info@sinirji.com</a>
            </span>
            <span style="color:white;float:right">
                <i style="color:darkorange" class="fa fa-phone"></i>
                <span> US &amp; Canada:</span>
                <strong>
                    <a style="color:white;" href="tel:+18443355590">1 (844) 335-5590</a>
                </strong>
            </span>
        </div>
    </div>

    <nav>
        <div class="ui secondary pointing large menu">

            <a class="logo-full" [href]="'/'" [routerLink]="'/'">
                <img class="logo-img" src="/assets/images/Sinirji_Logo.jpg" alt="Sinirji 911">
            </a>

            <a [href]="'/'" [routerLink]="'/'" class="item" [ngClass]="{active : test_url('/', true)}">
                Home
            </a>

            <a [href]="'/agencies'" [routerLink]="'/agencies'" class="item" [ngClass]="{active : test_url('/agenc', false)}">
                Agencies and Events
            </a>

            <a [href]="'/contact'" [routerLink]="'/contact'" class="item" [ngClass]="{active : test_url('/contact', true)}">
                Contact
            </a>

        </div>
    </nav>
</div>

<div class="nav nav-narrow">
    <nav>
        <div class="ui secondary pointing large menu">
            <a class="logo-small" [href]="'/'" [routerLink]="'/'">
                <img class="logo-img-small" src="/assets/images/Sinirji_Logo_Only.png" alt="Sinirji 911">
            </a>

            <a [href]="'/'" [routerLink]="'/'" class="item" [ngClass]="{active : test_url('/', true)}">
                Home
            </a>

            <a [href]="'/agencies'" [routerLink]="'/agencies'" class="item" [ngClass]="{active : test_url('/agenc', false)}">
                Agencies and Events
            </a>

            <div class="compact-menu">
                <i class="bars big icon" (click)="show_second_menu = !show_second_menu"></i>
            </div>
        </div>

        <div *ngIf="show_second_menu" class="second-menu">
            <a [href]="'/contact'" [routerLink]="'/contact'" class="item">
                <span>Contact</span>
            </a>
        </div>
    </nav>
</div>


// WEBPACK FOOTER //
// ./src/app/components/nav/nav.component.html